import logo from "../media/logo.png";
import login_logo from "../media/login_logo.png";
import newlogo from "../media/newlogo.png";
import dummy from "../media/dummy.png";   

const media = {
    logo,
    login_logo,
    newlogo,
    dummy

};
export default media;